import styled from '@emotion/styled';

export const SadaAppointmentTypeSelect = styled.div``;
